import classes from "./Skills.module.css";

import dotnetImg from "../../assets/skills/dotnet.png";
import javascriptImg from "../../assets/skills/javascript.png";
import bootstrapImg from "../../assets/skills/bootstrap.png";
import reactImg from "../../assets/skills/react.png";
import nodeJsImg from "../../assets/skills/node.png";
import firebaseImg from "../../assets/skills/firebase.png";
import csharpImg from "../../assets/skills/csharp.png";
import pythonImg from "../../assets/skills/python.png";
import mysqlImg from "../../assets/skills/mysql.png";
import flutterImg from "../../assets/skills/flutter.png";
import angularImg from "../../assets/skills/angular.png";
import typeScriptImg from "../../assets/skills/typescript.png";
import cypressImg from "../../assets/skills/cypress.png";
import neo4jImg from "../../assets/skills/neo4j.png";
import graphqlImg from "../../assets/skills/graphql.png";

const Skills = () => {
  return (
    <section className={classes.skills_section} id="skills">
      <h1>Skills</h1>

      <div className={`container ${classes.skills__container}`}>
        {/* Frontend */}
        <div className={classes.skills__frontend}>
          <h3>Frontend Development</h3>

          <div className={classes.skills__content}>
            <article className={classes.skills__details}>
              <img src={javascriptImg} alt="JavaScript" />
              <div>
                <h4>JavaScript</h4>
              </div>
            </article>

            <article className={classes.skills__details}>
              <img src={typeScriptImg} alt="TypeScript" />
              <div>
                <h4>TypeScript</h4>
              </div>
            </article>

            <article className={classes.skills__details}>
              <img src={reactImg} alt="React" />
              <div>
                <h4>React</h4>
              </div>
            </article>

            <article className={classes.skills__details}>
              <img src={flutterImg} alt="Flutter" />
              <div>
                <h4>Flutter</h4>
              </div>
            </article>

            <article className={classes.skills__details}>
              <img src={angularImg} alt="Angular" />
              <div>
                <h4>Angular</h4>
              </div>
            </article>

            <article className={classes.skills__details}>
              <img src={cypressImg} alt="Cypress" />
              <div>
                <h4>Cypress</h4>
              </div>
            </article>

            <article className={classes.skills__details}>
              <img src={bootstrapImg} alt="Bootstrap" />
              <div>
                <h4>Bootstrap</h4>
              </div>
            </article>
          </div>
        </div>

        {/* Backend */}
        <div className={classes.skills__backend}>
          <h3>Backend Development</h3>

          <div className={classes.skills__content}>
            <article className={classes.skills__details}>
              <img src={pythonImg} alt="Python" />
              <div>
                <h4>Python</h4>
              </div>
            </article>

            <article className={classes.skills__details}>
              <img src={csharpImg} alt="C Sharp" />
              <div>
                <h4>C#</h4>
              </div>
            </article>

            <article className={classes.skills__details}>
              <img src={dotnetImg} alt="ASP.NET" />
              <div>
                <h4>ASP.NET</h4>
              </div>
            </article>

            <article className={classes.skills__details}>
              <img src={firebaseImg} alt="Firebase" />
              <div>
                <h4>Firebase</h4>
              </div>
            </article>

            <article className={classes.skills__details}>
              <img src={graphqlImg} alt="GraphQL" />
              <div>
                <h4>GraphQL</h4>
              </div>
            </article>

            <article className={classes.skills__details}>
              <img src={neo4jImg} alt="Neo4j" />
              <div>
                <h4>Neo4j</h4>
              </div>
            </article>

            <article className={classes.skills__details}>
              <img src={nodeJsImg} alt="Node.js" />
              <div>
                <h4>Node.js</h4>
              </div>
            </article>

            <article className={classes.skills__details}>
              <img src={mysqlImg} alt="MySQL" />
              <div>
                <h4>MySQL</h4>
              </div>
            </article>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Skills;
